import { render, staticRenderFns } from "./EmptyListView.vue?vue&type=template&id=85bfe4f4&"
import script from "./EmptyListView.vue?vue&type=script&lang=js&"
export * from "./EmptyListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports